
import { defineComponent, ref } from 'vue'
import ModalBase from '@/views/modal/ModalBase.vue'
import LoadingButton from '@/views/components/LoadingButton.vue'
import { repositories } from '@/repositories/system/repositories'
import { callApiWrapper } from '@/views/callApiWrapper'
import DismissibleAlert from '@/views/components/DismissibleAlert.vue'

const repository = repositories.notice

export default defineComponent({
  components: {
    DismissibleAlert,
    LoadingButton,
    ModalBase
  },
  props: {
    noticeId: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  emits: {
    dismiss: () => true,
    deleted: () => true
  },
  setup (props, { emit }) {
    const requestError = ref<string | null>(null)
    const isWaiting = ref(false)

    const dismiss = () => {
      emit('dismiss')
    }

    const deleteNotice = async () => {
      isWaiting.value = true
      await callApiWrapper(requestError, async () => {
        await repository.deleteNotice(props.noticeId)
        emit('deleted')
      })
      isWaiting.value = false
    }

    return {
      requestError,
      isWaiting,
      dismiss,
      deleteNotice
    }
  }
})
